const myMixin = {
    data() {
        return {
        };
    },
    methods: {
        goList(type){
            this.$router.push(`/info?type=${type}`);
        },
        goDetail(id){
            window.open(`/detail?id=${id}`)
            // this.$router.push(`/detail?id=${id}`);
        }
    },
};
export default myMixin;